/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCommissionAgreementCommand } from '../../models/create-commission-agreement-command';
import { Int32ApiResponse } from '../../models/int-32-api-response';

export interface CreateCommissionAgreementAsync$Params {
  contractId: number;
      body?: CreateCommissionAgreementCommand
}

export function createCommissionAgreementAsync(http: HttpClient, rootUrl: string, params: CreateCommissionAgreementAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createCommissionAgreementAsync.PATH, 'post');
  if (params) {
    rb.path('contractId', params.contractId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Int32ApiResponse>;
    })
  );
}

createCommissionAgreementAsync.PATH = '/api/commission-agreement/{contractId}';
